import { useState } from 'react';
import { getCategories } from '../services/Api';

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCategories = async (searchTerm = '') => {
    setLoading(true);
    try {
      const response = await getCategories(searchTerm);
      
      // Check if response indicates an error
      if (response.status === 422 || response.status === 401) {
        throw new Error(response.message || 'Authentication failed');
      }
      
      const categorySuggestions = response.data?.data?.categorySuggestions || [];
      setCategories(categorySuggestions);
      setFilteredCategories(categorySuggestions);
      return categorySuggestions;
    } catch (error) {
      console.error("Error fetching categories", error);
      
      // Re-throw the error with proper message
      if (error.response?.data) {
        const errorData = error.response.data;
        throw new Error(errorData.message || 'Failed to fetch categories');
      } else if (error.message) {
        throw new Error(error.message);
      } else {
        throw new Error('Failed to fetch categories');
      }
    } finally {
      setLoading(false);
    }
  };

  const filterCategories = (searchTerm) => {
    if (!searchTerm.trim()) {
      setFilteredCategories(categories);
      return;
    }

    const filtered = categories.filter(category =>
      category.categoryName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      category.categoryPath.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCategories(filtered);
  };

  return {
    categories,
    filteredCategories,
    loading,
    fetchCategories,
    filterCategories
  };
};